import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';
import { formatShippingCurrency, useShippingSettings } from '../hooks/useShippingSettings';

const ShippingDelivery = () => {
  const [shippingGroups, setShippingGroups] = useState([]);
  const shippingSettings = useShippingSettings();

  useEffect(() => {
    fetch(`${API_BASE_URL}/Category/api/category-shipping-times`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
            console.log(data);
          buildShippingGroups(data.categories);
        }
      })
      .catch(err => console.error('Failed to fetch shipping times:', err));
  }, []);

  const buildShippingGroups = (categories) => {
  const groupConfig = [
    {
      title: 'SHIRTS',
      keywords: ['shirts'],
      image: '/assets/images/shipping_shirt.png',
    },
    {
      title: 'PANTS',
      keywords: ['pants', 'casual pants'],
      image: '/assets/images/shipping_pants.png',
    },
    {
      title: 'SUITS & SPORTS COATS',
      keywords: ['suits', 'sports coats', 'jackets', 'blazers'],
      image: '/assets/images/shipping_jacket.png',
    },
    {
      title: 'STOCKED PRODUCTS (OUTWEAR & ACCESSORIES)',
      keywords: ['outwear', 'accessories', 'stocked products'],
      image: '/assets/images/shipping_tie.png',
    },
  ];

  const groups = groupConfig.map(group => {
    const matched = categories.filter(cat =>
      group.keywords.some(keyword =>
        (cat.categoryTitle || '').toLowerCase().includes(keyword.toLowerCase())
      )
    );

    const minDays = matched.length ? Math.min(...matched.map(c => c.minDeliveryDays || 0)) : null;
    const maxDays = matched.length ? Math.max(...matched.map(c => c.maxDeliveryDays || 0)) : null;

    return {
      title: group.title,
      image: group.image,
      minDays,
      maxDays,
      estimatedDate: calculateEstimatedDate(minDays, maxDays)
    };
  });

  setShippingGroups(groups);
};

  const calculateEstimatedDate = (min, max) => {
    if (!min || !max) return 'N/A';

    const today = new Date();
    const minDate = new Date(today);
    const maxDate = new Date(today);

    minDate.setDate(today.getDate() + min);
    maxDate.setDate(today.getDate() + max);

    const format = (date) => date.toLocaleString('en-US', { month: 'short', day: 'numeric' });

    return min === max ? `${format(maxDate)}` : `${format(minDate)} - ${format(maxDate)}`;
  };

  const getDeliveryRangeText = (min, max) => {
    if (!min || !max) return '(N/A)';
    return min === max ? `(${max} Days)` : `(${min}-${max} Days)`;
  };

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <div className="text-center pt--50">
          <h1>Shipping & Delivery</h1>
        </div>

        <div className="container my-5">
          <div className="row gy-4">
            {shippingGroups.map((group, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <div className="shipping-card">
                  <img src={group.image} alt={group.title} />
                  <h6>{group.title}</h6>
                  <p className="delivery-date">{getDeliveryRangeText(group.minDays, group.maxDays)}</p>
                  <p className="shipping-info">
                    {group.title === 'STOCKED PRODUCTS' ? 'Order now for delivery by' : 'Custom made & delivered by'}<br />
                    <strong>{group.estimatedDate}</strong>
                  </p>
                  <a href="/shipping-delivery" className="shipping-btn">{shippingSettings.freeShippingMessage}</a>
                  <p className="small">or {formatShippingCurrency(shippingSettings.fixedCharge, shippingSettings)} Flat Rate</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ShippingDelivery;
